import React, {useEffect, useRef, useState} from 'react';
import "./Shipping.scss";
import {Calendar} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import {Spin} from "antd";

function TimesCard({time,selected,setSelected}) {
    return(
        <div
             className={selected.from===time.from?"shipping-item selected-time":"shipping-item"}
             onClick={e=>{
            setSelected(time)
        }}>
            <span>{`${time.from} - ${time.to}`}</span>
        </div>
    )
}


function Shipping({selTime,selDate}) {

    const [loading,set_loading] = useState(false);
    const [selectedTime,set_selectedTime] = useState("");


    const setTime = (val)=>{
        set_selectedTime(val)
        selTime(val)
    }


    const reFetchShippingTime = (e)=>{
        console.log(e)
        selDate(e)
        set_times([])
        set_selectedTime("")
        set_loading(true);
        setTimeout(()=>{
            set_times([
                {from:"8:30",to:"9:00"},
                {from:"9:00",to:"9:30"},
                {from:"9:30",to:"10:00"},
                {from:"10:00",to:"10:30"},
                {from:"10:30",to:"11:00"},
                {from:"11:00",to:"11:30"},
                {from:"11:30",to:"12:00"},
                {from:"12:00",to:"12:30"},
                {from:"12:30",to:"13:00"},
                {from:"13:00",to:"13:30"},
                {from:"13:30",to:"14:00"},
                {from:"14:00",to:"14:30"},
                {from:"14:30",to:"15:00"},
                {from:"15:00",to:"15:30"},
                {from:"15:30",to:"16:00"},
                {from:"16:30",to:"17:00"},
                {from:"17:00",to:"17:30"},
                {from:"17:30",to:"18:00"}
                ])
            set_loading(false);
        },2000)
    }

    const [times,set_times] = useState([
        {from:"8:30",to:"9:00"},
        {from:"9:00",to:"9:30"},
        {from:"9:30",to:"10:00"},
        {from:"10:00",to:"10:30"},
        {from:"10:30",to:"11:00"},
        {from:"11:00",to:"11:30"},
        {from:"11:30",to:"12:00"},
        {from:"12:00",to:"12:30"},
        {from:"12:30",to:"13:00"},
        {from:"13:00",to:"13:30"},
        {from:"13:30",to:"14:00"},
        {from:"14:00",to:"14:30"},
        {from:"14:30",to:"15:00"},
        {from:"15:00",to:"15:30"},
        {from:"15:30",to:"16:00"},
        {from:"16:30",to:"17:00"},
        {from:"17:00",to:"17:30"},
        {from:"17:30",to:"18:00"}
    ]);



    return (
            <div className="schedule-container">
                <div className="resource-section">

                    {/*<div className="resource-row">*/}
                    {/*    <div className="resource-item">*/}
                    {/*        <select name="" id="">*/}
                    {/*            <option value="">سرویس 1</option>*/}
                    {/*            <option value="">سرویس 2</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*    <div className="resource-item">*/}
                    {/*        <select name="" id="">*/}
                    {/*            <option value="">سرویس 4</option>*/}
                    {/*            <option value="">سرویس 5</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<div className="resource-row">*/}
                    {/*    <div className="resource-item">*/}
                    {/*        <select name="" id="">*/}
                    {/*            <option value="">میز شماره 12</option>*/}
                    {/*            <option value="">میز شماره 13</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*    <div className="resource-item">*/}
                    {/*        <select name="" id="">*/}
                    {/*            <option value="">لژ خانوادگی</option>*/}
                    {/*            <option value="">میز تکی</option>*/}
                    {/*            <option value="">میز 5 نفره</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
                <div className="shipping-section">
                    <div className="shipping-col calender-container" >
                        <Calendar
                            calendar={persian}
                            locale={persian_fa}
                            onChange={e => {
                                reFetchShippingTime(e)
                                console.log(e.toDate?.().toString())
                            }}
                        />
                    </div>


                        <div className="shipping-col time-sec" style={loading?{paddingTop:100}:{paddingTop:0}}>
                            <Spin spinning={loading}>
                                {times.map(t=>{
                                    return(
                                        <TimesCard time={t} selected={selectedTime} setSelected={setTime}/>
                                    )
                                })}
                            </Spin>
                        </div>


                </div>
            </div>
    )
}

export default Shipping
